<template>
  <f7-page name="lms-sigmet" style="position:relative;" @page:init="onPageInit" @page:beforeout="onPageBeforeOut" @page:beforeremove="onPageBeforeRemove">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>SIGMET</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template>
      <f7-toolbar bottom v-if="isImagesLoaded">
        <f7-block class="tp-toolbar">
          <f7-row>
            <f7-col width="33" class="tp2-time">
              {{ currentItemTime }}
            </f7-col>
            <f7-col width="50">
              <f7-range
                  class="tp-range"
                  ref="tpRangeSlider"
                  :min="1"
                  :max="this.tpMaxImages"
                  :step="1"
                  :value="this.currentImageIndex"
                  color="blue"
                  :disabled="(!isImagesLoaded || isPlaying)"
                  @range:change="rangeChanged"
              ></f7-range>
            </f7-col>
            <f7-col width="15">
              <f7-button class="tp-play-btn" :disabled="!isImagesLoaded" @click="animPlay()" :icon-f7="playIcon"></f7-button>
            </f7-col>

          </f7-row>
        </f7-block>
      </f7-toolbar>


      <l-map :options="mapOptions"
             ref="tpMap"
             @ready="initMap()"
      >
        <l-control-zoom position="bottomright"></l-control-zoom>
        <l-image-overlay
            ref="layerImg"
            :url="imageUrl"
            :bounds="imageBounds"
            :maxBounds="imageBounds"
            :center="[0,0]"
        />
      </l-map>

    </template>
    <image-preloader
        :srcs="imagesToPreload"
        @loaded-all="imageLoadedAll"
        @loaded="imageLoadedOne"
        @onerror="imagePreloadError"
    />



  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import imagePreloader from '../components/imagePreloader'
import {LControlZoom, LImageOverlay, LMap, LMarker, LTileLayer} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

var progressDialog, loadingDialog;

export default {
  components: {
    'image-preloader': imagePreloader,
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LControlZoom
  },
  data: function () {
    return {
      tpData: [],
      isDataLoaded: false,
      isImagesLoaded: false,
      lastUpdated: 0,
      tCheckInterval: null,
      playIcon: 'play_fill',
      isPlaying: false,
      currentItemTime: '00:00',
      imagesToWalk: [],
      preloaderLoaded: 0,
      currentImageIndex: 1,
      imageUrl: 'static/shmu/img/blank.png',
      base_url: '',
      animTimer: null,
      stopTimer: null,
      tpNumImages: 4,
      tpAnimSpeed: 6,
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        minZoom: 1,
        maxZoom: 4,
        zoom: 2,
        crs: L.CRS.Simple

      },
      imageBounds: [[85.05, -31.46], [65.585, -180]]

    };
  },
  watch: {
    isPlaying: function (val) {
      if (val === true) {
        this.playIcon = 'pause_fill';
      } else {
        this.playIcon = 'play_fill';
      }
    },
    tpAnimSpeed(val) {
      if (this.isPlaying) {
        this.animPlay(); // zastavime
        this.animPlay(); // spustime
      }
    },
    imagesToWalk(val) {
      this.tpMaxImages = val.length;
    },
  },
  computed: {


    animSpeed() {
      return (11 - this.tpAnimSpeed) * 100;
    },
    imagesToPreload() {
      const tpData = this.tpData;
      let finalToLoad = [];

      if (tpData.length > 0) {

        this.imagesToWalk = tpData.sort((a, b) => (a.dt > b.dt) ? 1 : -1);
        this.imagesToWalk.forEach((v) => {
          finalToLoad.push(SHMUconf.SHMU_CORE_URL + 'data/' + v.file_link);
        });

        if (finalToLoad.length > 0) {
          progressDialog = this.$f7.dialog.progress('Načítavam obrázky SIGMET...', 0);
        }

        return finalToLoad;
      }
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');

    this.$nextTick(() => {
      this.initMap();
    });


  },
  updated: function () {
    const self = this;
    this.$nextTick(function () {
      if (self.$f7.range.get('.tp-range')) {
        if (this.tpMaxImages !== self.$f7.range.get('.tp-range').max) {
          self.$f7.range.get('.tp-range').max = this.tpMaxImages;
        }
      }
    })
  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        loadingDialog = self.$f7.dialog.preloader('Načítavam...');

        Axios.get(SHMUconf.API_BASE_URL + 'lms/getsigmet', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.tpData = response.data.data;
                self.isDataLoaded = true;
                self.lastUpdated = self.$moment().unix();
                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 60 * 1000); // overujem kazdu minutu
              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať informácie o SIGMET', 'Nastala chyba');
              }

              loadingDialog.close();
              loadingDialog = null;
            }).catch((error) => {
          loadingDialog.close();
          loadingDialog = null;
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }


    },

    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 3 * 60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    imageLoadedOne(e) {
      progressDialog.setProgress(e.progress);
      progressDialog.setText(e.count + ' z ' + e.length);
    },
    imageLoadedAll(e) {
      progressDialog.close();
      progressDialog = null;
      this.isImagesLoaded = true;
      this.setImage(this.tpMaxImages);

      this.$nextTick(() => {
        this.$$('.tp-range, .range-slider, .range-bar, .range-knob, .range-knob-wrap, .range-bar-active').on('click', this.tpRangeClicked);
      });

    },
    imagePreloadError(e) {
      const self = this;
      if (progressDialog !== null) {
        progressDialog.close();
        progressDialog = null;
      }
      this.isImagesLoaded = true;
      this.setImage(this.tpMaxImages);

      this.$nextTick(() => {
        this.$$('.tp-range, .range-slider, .range-bar, .range-knob, .range-knob-wrap, .range-bar-active').on('click', this.tpRangeClicked);
      });

      self.$f7.dialog.alert('Niektoré obrázky sa nepodarilo načítať.', 'Nastala chyba');
      console.log('Nepodarilo sa nacitat: ',  e.errorImgs);
    },
    rangeChanged(val) {
      if (!this.isPlaying) {
        this.setImage(val);
      }
    },
    tpRangeClicked(e) {
      if (this.isPlaying) {
        this.isPlaying = false;
        clearInterval(this.animTimer);
      }
    },
    setImage(i) {
      if (i >= this.tpMaxImages) {
        i = this.tpMaxImages;
      }
      this.currentImageIndex = i;
      let fname = '';
      let dt;
      this.imagesToWalk.forEach((v, ii) => {
        if (ii + 1 === i) {
          fname = v.file_link;
          dt = v.dt;
          return;
        }
      });
      if (fname !== '') {
        this.imageUrl = SHMUconf.SHMU_CORE_URL + 'data/' + fname;
        this.currentItemTime = this.$moment(dt).format('DD.MM.YYYY HH:mm');
      }
    },
    anim() {
      this.animTimer = setInterval(() => {
        if (this.currentImageIndex === this.tpMaxImages) {
          clearInterval(this.animTimer);
          this.restartAnimPlay(1);
          // this.setImage(1);
        } else {
          this.setImage(this.currentImageIndex + 1);
        }

      }, this.animSpeed)
    },
    animPlay() {
      if (this.isPlaying) {
        clearInterval(this.animTimer);
        clearTimeout(this.stopTimer);
        this.isPlaying = false;
      } else {
        this.isPlaying = true;
        this.anim();
      }
    },
    restartAnimPlay(index) {
      const self = this;
      this.stopTimer = setTimeout(function(){
        self.setImage(index);
        self.anim();
      }, this.animSpeed * 1.75)
    },
    onPageBeforeOut() {
      const self = this;
      clearInterval(this.animTimer);
      clearTimeout(this.stopTimer);
      // console.log('onPageBeforeOut');
      // Close opened sheets on page out
      self.$f7.sheet.close();
    },
    onPageBeforeRemove() {
      const self = this;
      clearInterval(this.animTimer);
      clearTimeout(this.stopTimer);
      // console.log('onPageBeforeRemove');
      // Destroy sheet modal when page removed
      if (self.sheet) self.sheet.destroy();
    },
    initMap() {
      const self = this;
      this.$$('.leaflet-control-attribution a').each((i, item) => {
        self.$$(item).addClass('external')
      });

      let w = 1200;
      let h = 839;

      if (this.$refs.tpMap) {
        let map = this.$refs.tpMap.mapObject;
        let southWest = map.unproject([0, h], map.getMaxZoom() - 1);
        let northEast = map.unproject([w, 0], map.getMaxZoom() - 1);
        self.imageBounds =  new L.LatLngBounds(southWest, northEast);
        map.setMaxBounds(self.imageBounds);
      }


    },


  }



}
</script>

<style lang="scss">

.tp-time {
  font-weight: normal;
  font-size:0.9rem;
  white-space: nowrap;
}

.md {
  .tp2-time {
    padding-top:0.6rem;
    font-size: 11px;
  }

  .tp-settings {
    padding-top:0.3rem;
    margin-left:0.5rem;
  }

  .tp-play-btn {
    padding-top: 0.3rem;
    padding-left: 0.5rem;
  }

  .tp-range {
    padding-top: 1.1rem;
  }
}
.tp-toolbar {
  max-width:400px;
  width:100%;
  margin: 0px auto;
}


</style>
